import styled, { css } from 'styled-components';
import { inputPadding, InputSize } from './Input.styles';
import { cssVar } from 'styles/helper';
import { RadiusPropKeys } from 'styles/spacing';
import Stack from 'atoms/Layout/Stack/Stack';
import Clickable from 'atoms/Clickable/Clickable';

interface DropdownContainerProps {
  $size: InputSize;
  $borderRadius?:
    | RadiusPropKeys
    | {
        topRight?: RadiusPropKeys;
        bottomRight?: RadiusPropKeys;
        bottomLeft?: RadiusPropKeys;
        topLeft?: RadiusPropKeys;
      };
}

export const DropdownContainer = styled.div<DropdownContainerProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${cssVar('border-primary')};
  background-color: ${cssVar('bg-primary')};
  transition: all 0.2s ease-in-out;
  box-shadow: ${cssVar('shadow-xs')};
  position: relative;
  gap: ${cssVar('spacing-sm')};

  ${({ $borderRadius }) => {
    if (typeof $borderRadius === 'string') {
      return css`
        border-radius: ${cssVar($borderRadius)};
      `;
    }

    if (typeof $borderRadius === 'object') {
      return css`
        border-radius: ${cssVar($borderRadius.topLeft || 'radius-none')}
          ${cssVar($borderRadius.topRight || 'radius-none')} ${cssVar($borderRadius.bottomRight || 'radius-none')}
          ${cssVar($borderRadius.bottomLeft || 'radius-none')};
      `;
    }
  }}

  ${({ $size }) => css`
    padding: ${inputPadding[$size]};
  `}

  &:hover {
    border-color: ${cssVar('border-secondary')};
  }

  &:focus-within {
    border-color: ${cssVar('border-brand')};
    box-shadow: 0 0 0 2px ${cssVar('focus-ring')};
  }
`;

export const OptionsList = styled(Stack)`
  top: 100%;
  left: 0;
  min-width: 100%;
  z-index: 10;
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.2s ease-in-out;
`;

export const OptionListContent = styled(Stack)`
  border: 1px solid ${cssVar('border-secondary-alt')};
  transition: max-height 300ms ease-in-out;
  box-shadow: ${cssVar('shadow-lg')};

  .dropdown-option {
    transition: all 0.2s ease-in-out;
    border-radius: ${cssVar('radius-sm')};

    &:hover {
      background: ${cssVar('bg-primary-hover')};
    }
  }
`;

export const ClickableContainer = styled(Clickable)`
  width: 100%;
`;
